import { jsxs as ae, Fragment as Fe, jsx as A } from "react/jsx-runtime";
import { memo as ce, useRef as _, useState as F, useMemo as f, useCallback as i } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact as Ae } from "ag-grid-react";
import ie from "classnames";
import { merge as Le } from "lodash";
import { noop as d } from "lodash/fp";
import { DEFAULT_FEATURES_STATE as Ue, DEFAULT_NUMERIC_CONFIGURATIONS as Be, ROW_HEIGHTS as le, CUSTOM_CELLS_THAT_NOT_OPEN_DRAWER as ze, HEADER_HEIGHTS as $e, DEFAULT_NO_RESULTS as W } from "./index.es531.js";
/* empty css            */
import { useTheme as Pe } from "./index.es173.js";
import { generateColDefs as We } from "./index.es533.js";
import { useCustomIcons as je } from "./index.es534.js";
import { getOverrideTableComponents as Ke } from "./index.es535.js";
import { getRowClass as qe } from "./index.es536.js";
import { generatePlaceholderRows as Qe } from "./index.es537.js";
import { ActionToolbar as Ve } from "./index.es538.js";
import { DrawerTemplate as Je } from "./index.es115.js";
import { NoRowsComponent as Xe } from "./index.es539.js";
import { onKeyDownEnter as Ye } from "./index.es500.js";
const Ze = ce(Xe), et = (L, l, u, g) => {
  const m = l || L ? "filter" : "default", p = W[m].testId, E = {
    ...W,
    filter: {
      ...W.filter,
      buttonText: u ? "Reset Filters" : void 0,
      onButtonClick: () => u == null ? void 0 : u()
    }
  }, s = Le(E[m], g == null ? void 0 : g[m]);
  return () => /* @__PURE__ */ A(Ze, { ...s, testId: p });
};
function tt(L) {
  var se;
  const {
    columns: l,
    excludedColumnsFromSelection: u,
    quickFilterText: g,
    isDataFiltered: U,
    tableContainerHeight: m,
    cornerRadius: p,
    overrideNoResult: E,
    loading: s,
    alwaysShowColumnsDivider: j = !0,
    maxRowSelection: h,
    maxRowSelectedCallBack: T = d,
    rowData: B = [],
    loadingRows: H = [],
    testId: D = "data-grid",
    rowSelection: de = "multiple",
    gridDensity: o = "standard",
    columnSelectionType: I = "off",
    features: C = Ue,
    numericConfigurations: G = Be,
    getGridApi: K = d,
    onRowsSelected: q = d,
    onColumnSelect: Q = d,
    onCellValueChanged: ue = d,
    onRowDragEnd: pe = d,
    onRowClicked: me = d,
    onCellClicked: V = d,
    onCellKeyDown: k = d,
    onGridReady: J = d,
    onResetFilters: X,
    getRowId: fe,
    ...ge
  } = L, v = _(null), [n, Ce] = F(), [x, we] = F([]), [z, Y] = F(void 0), [b, $] = F(!1), Z = _(), ee = _([]), c = _(null), { cornerRadius: he } = Pe(), { pagination: De, bulkEditable: P, filter: R, drawer: r, ...te } = C, y = p ? he[p] : void 0, Re = f(() => {
    const e = {
      "--ag-header-column-separator-width": "2px",
      "--ag-header-column-separator-height": "30%",
      "--ag-header-column-separator-color": "var(--plac-lines-default)",
      "--ag-header-column-separator-display": "flex"
    }, t = {
      "--ag-row-height": `${le[o]}px`,
      "--ag-wrapper-border-radius": p ? y : "0px",
      height: m
    };
    return !C.resizable && j ? { ...t, ...e } : t;
  }, [
    o,
    p,
    y,
    m,
    C.resizable,
    j
  ]), be = f(
    () => ie("pl-ag-container", {
      hasCornerRadius: !!p,
      loading: !!s
    }),
    [p, s]
  ), ye = f(() => ie("data-grid", o), [o]), oe = f(
    () => I !== "off" && !R,
    [I, R]
  ), Oe = f(() => {
    const e = {
      columns: l,
      gridDensity: o,
      numericConfigurations: G,
      selectedColumn: x,
      filter: R,
      testId: D,
      loadingRows: H,
      loading: s
    };
    if (!c.current || c.current.columns !== l || c.current.gridDensity !== o || c.current.numericConfigurations !== G || c.current.selectedColumn !== x || c.current.filter !== R || c.current.testId !== D || c.current.loadingRows !== H || c.current.loading !== s) {
      const a = {
        filter: R,
        ...te,
        propsToDrill: { gridDensity: o, testId: D },
        numericConfigurations: G,
        loadingRows: H,
        loading: s
      };
      ee.current = We(l, a, x), c.current = e;
    }
    return ee.current;
  }, [
    l,
    o,
    G,
    te,
    x,
    R,
    D,
    H,
    s
  ]), Se = je(), Ee = f(
    () => et(
      U,
      g,
      X,
      E
    ),
    [U, g, X, E]
  ), Te = i(
    (e) => {
      if (!n) return;
      const t = n.getSelectedNodes();
      !h || h && t.length <= h ? (q(t), t != null && t.length ? Y(t.length) : Y(void 0)) : h && t.length > h && (e.node.setSelected(!1), T == null || T());
    },
    [n, T, h, q]
  ), He = i(
    (e) => {
      const a = e.column.getColDef().field;
      oe && a && !(u != null && u.includes(a)) && we((Me) => {
        let w = [...Me];
        return I === "single" ? w = [a] : w.includes(a) ? w = w.filter((_e) => _e !== a) : w.push(a), Q(w), w;
      });
    },
    [
      I,
      u,
      oe,
      Q
    ]
  ), N = i(
    (e, t, a) => {
      var S;
      r && (a && r.isOpeningManualHandled || (C.editable ? console.warn("DataGrid: Editable Cells Do not work with drawer") : ($(!0), (S = r.onOpenedBy) == null || S.call(r, e, t), Z.current = t)));
    },
    [r, C.editable]
  ), M = i(() => {
    $(!1);
  }, []), ne = i(() => b, [b]), re = i(
    (e, t) => {
      r && (!C.editable && !r.isOpeningManualHandled ? e === Z.current && b && r.isClosingByClickOfSameRow ? M() : N(t, e, !0) : console.warn(
        r.isOpeningManualHandled ? "DataGrid: Manual Drawer Mode is Enabled" : "DataGrid: Editable Cells Do not work with drawer"
      ));
    },
    [r, C.editable, b, N, M]
  ), O = i(
    (e) => {
      const t = e.colDef.type || "";
      ze.includes(t) || re(e.rowIndex, e.data), V(e);
    },
    [re, V]
  ), Ie = i(
    (e) => {
      Ye(e.event, () => O == null ? void 0 : O(e)), k == null || k(e);
    },
    [O, k]
  ), Ge = i(
    (e) => {
      const t = e.api;
      t.openDrawer = (a, S) => N(a, S, !1), t.closeDrawer = M, t.isDrawerOpen = ne, J(e), Ce(t), K(t);
    },
    [K, N, M, ne, J]
  ), ke = i(
    (e) => {
      e.api.refreshHeader(), (n == null ? void 0 : n.getDisplayedRowCount()) === 0 ? n == null || n.showNoRowsOverlay() : n == null || n.hideOverlay();
    },
    [n]
  ), ve = f(
    () => Ke({ gridDensity: o }),
    [o]
  ), xe = i(
    (e) => qe(e, l, s),
    [l, s]
  ), Ne = f(() => {
    var e;
    return s && B.length === 0 ? Qe(
      l,
      o,
      m ?? ((e = v.current) == null ? void 0 : e.clientHeight)
    ) : B;
  }, [s, B, l, o, m]);
  return /* @__PURE__ */ ae(Fe, { children: [
    /* @__PURE__ */ ae(
      "div",
      {
        className: be,
        "data-testid": `${D}-container`,
        style: Re,
        ref: v,
        children: [
          /* @__PURE__ */ A(
            Ae,
            {
              animateRows: !0,
              suppressRowClickSelection: !0,
              suppressDragLeaveHidesColumns: !0,
              rowDragManaged: !0,
              stopEditingWhenCellsLoseFocus: !0,
              singleClickEdit: !0,
              tooltipShowDelay: 0,
              tabIndex: 0,
              rowData: Ne,
              rowSelection: de,
              quickFilterText: g,
              icons: Se,
              className: ye,
              columnDefs: Oe,
              headerHeight: $e[o],
              rowHeight: le[o],
              getRowClass: xe,
              components: ve,
              onGridReady: Ge,
              onRowDragEnd: pe,
              onRowSelected: Te,
              onColumnHeaderClicked: He,
              onFilterChanged: ke,
              onCellValueChanged: ue,
              getRowId: fe,
              noRowsOverlayComponent: Ee,
              onCellKeyDown: Ie,
              onRowClicked: me,
              onCellClicked: O,
              rowBuffer: 20,
              cacheQuickFilter: !0,
              ...De,
              ...ge
            }
          ),
          P && z !== void 0 && /* @__PURE__ */ A(
            Ve,
            {
              visible: P && !!z,
              selectedCount: z,
              testId: D + "-action-toolbar",
              ...P
            }
          )
        ]
      }
    ),
    r && /* @__PURE__ */ A(
      Je,
      {
        ...r,
        setIsOpen: $,
        isOpen: b,
        container: v.current,
        height: `${((se = v.current) == null ? void 0 : se.clientHeight) - 2}px`,
        customPosition: p ? { top: "1px", right: "1px" } : {},
        customBorderRadius: y ? `0px ${y} ${y} 0px` : void 0
      }
    )
  ] });
}
const ot = ce(tt);
ot.displayName = "DataGrid";
export {
  ot as DataGrid
};
//# sourceMappingURL=index.es522.js.map
